import { Products } from '@strim/gateway-api';

import { pluralize } from '@rikstv/play-common/src/utils/string-i18n/string.i18n.utils';

function formatDiscountDuration(numberOfBillingCycles: number, short = false): string {
  if (short) {
    return `${numberOfBillingCycles} mnd`;
  }
  return pluralize(numberOfBillingCycles, 'en måned', `${numberOfBillingCycles} måneder`);
}

export const getCampaignDiscountText = (
  discounts: NonNullable<Products.Product['campaign']>['discounts'],
  productName?: string,
  short = false,
  monthsPassed = 0,
  isFirst = true
): string => {
  if (discounts.length === 0) return '';

  const sortedDiscounts = [...discounts].sort(
    (a, b) => (a.numberOfBillingCycles ?? Infinity) - (b.numberOfBillingCycles ?? Infinity)
  );

  // Consume every discount sharing the current duration in one stage so siblings don't recurse into "0 måneder"
  const currentBillingCycles = sortedDiscounts[0].numberOfBillingCycles;
  const remainingDiscounts = sortedDiscounts.filter(d => d.numberOfBillingCycles !== currentBillingCycles);
  const remainingAmountSum = sortedDiscounts.reduce((sum, discount) => sum + (discount.reducedAmount ?? 0), 0);

  const prefix = isFirst ? '' : ' og deretter ';
  const productPart = isFirst && productName ? ` på ${productName}` : '';
  // Infinite discounts have no billing-cycle count, so omit the duration entirely
  const durationPart =
    currentBillingCycles != null ? ` i ${formatDiscountDuration(currentBillingCycles - monthsPassed, short)}` : '';

  return (
    `${prefix}${remainingAmountSum} kr i rabatt${productPart}${durationPart}` +
    getCampaignDiscountText(remainingDiscounts, productName, short, currentBillingCycles ?? monthsPassed, false)
  );
};
